/**
 * LocationIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LocationIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 2a7 7 0 0 0-7 7c0 4.17 4.41 9.91 6.23 12.1a1 1 0 0 0 1.54 0C14.59 18.91 19 13.17 19 9a7 7 0 0 0-7-7m0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LocationIcon = makeIcon('LocationIcon', LocationIconSvg)
